var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"userHasNoActivity"},[_c('p',{directives:[{name:"t",rawName:"v-t",value:('noUserActivity'),expression:"'noUserActivity'"}],staticClass:"userHasNoActivity__text",attrs:{"data-cy":"noUserActivity"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }